import http from '@services/http';
import { Posts } from './interfaces';

export const queue = (data: Posts.QueueFileUpload.Request): Promise<Posts.QueueFileUpload.Response> => {
  return http.post(`/admin/posts/uploads`, data);
};

export const start = (data: Posts.StartFileUpload.Request): Promise<Posts.StartFileUpload.Response> => {
  return http.post(`/admin/posts/uploads/${data.fileUploadId}`, data);
};